/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* Partition segment classification
*/
export enum PartitionSegmentType {
  PARTITION_SEGMENT_TYPE_PRIMARY = 'PRIMARY',
  PARTITION_SEGMENT_TYPE_SECONDARY = 'SECONDARY',
  PARTITION_SEGMENT_TYPE_DATE = 'DATE'
}
